module.exports = __webpack_public_path__ + "img/collection-weddingRingsCarbon@2x.fd44e32.jpg";